import React, { useEffect } from "react";
import MainCard from "../../../components/Maincard";
import { Box, Grid, MenuItem, TextField, Typography } from "@mui/material";
import NewCardcomp from "../../../components/card/NewCardcomp";
import { useState } from "react";
import CustomAutocompleteComp from "../../../newTestPrep/newComponent/AutocompleteComp";
import SearchButton from "../../../newTestPrep/newComponent/NewButtonComp/SearchButton";
import HeadingCard from "../../../newTestPrep/newComponent/NewCardsComp/HeadingCard";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import LoaderComp from "../../../newTestPrep/newComponent/LoaderComp/Loader";
import { useGetTokenOrLogout } from "../../../utils/token";
import CustomPopup from "../../../components/CustomPopup";
import { Details } from "@mui/icons-material";
import ProductDetailsData from "./ProductDetailsData";
import { useNavigate } from "react-router-dom";
import CustomTextFieldComp from "../../../newTestPrep/newComponent/customTextFieldComp";
import { validateCurrency } from "../../../utils/formatTime";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function ProductWiseRevenueReport() {
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const navigate = useNavigate();
  const getTokenOrLogout = useGetTokenOrLogout();
     const [countryList, setCountryList] = useState([]);
          const [countryName, setCountryName] = useState(101);
  const [productList, setProductList] = useState([]);
  const [productName, setProductName] = useState([]);
  const [selectedYear, setSelectedYear] = useState({
    year: new Date().getFullYear(),
  });

  const years = Array.from({ length: 5 }, (_, index) => ({
    year: new Date().getFullYear() - 3 + index,
  }));

  const [productData, setProductData] = useState([]);
  const [isLoading, setIsLoading] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [detailsData, setDetailsData] = useState([]);
  const [detailsPopup, setDetailsPopup] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleselectedYear = async (value) => {
    setSelectedYear(value);
  };

   useEffect(() => {
          fetch(`${API_ENDPOINT}country`)
            .then((response) => response.json())
            .then((data) => {
              const filteredCountry = data.filter(
                (i) => i.country_name === "India" || i.country_name === "Nepal"
              );
              setCountryList(filteredCountry);
            })
            .catch((error) => {
              console.error("Error fetching state:", error);
            });
        }, []);

           const handleChangeCountry = (e) => {

      setCountryName(e.target.value);
    };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}product`);
        if (response.ok) {
          const data = await response.json();
          setProductList(data);
          setProductName(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const allProductList = [{ name: "Select All" }, ...productList];
  const handleAllChhangeProduct = (e, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setProductName(productList);
    } else {
      setProductName(value);
    }
  };

  const handleSearchData = async () => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    setIsLoading(true);

    const requestData = {
      user_id: parseInt(userId),
      year: selectedYear?.year,

      product_id: productName.map((i) => i.id),
      country_id : countryName
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisor-rev-target/product-wise-report`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        setProductData(result);
        setIsLoading(false);
      } else if (response.status === 401) {
        navigate("/page401");
        setIsLoading(false);
      } else if (response.status === 403) {
        navigate("/page403");
      } else {
        showSnackbar("server Error", "error");
        setIsLoading(false);
      }
    } catch (error) {
      showSnackbar("server Error", "error");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleSearchData();
  }, []);

  const handleOpenPopup = () => {
    setDetailsPopup(true);
  };

  const handleClosePopup = () => {
    setDetailsPopup(false);
  };

  const getMoreDetails = async (productId) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    setIsLoading(true);

    const requestData = {
      user_id: parseInt(userId),
      year: selectedYear?.year,

      product_id: productId,
      country_id : countryName
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisor-rev-target/product-wise-report-with-month `,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        handleOpenPopup();
        setDetailsData(result);
        setIsLoading(false);
      } else if (response.status === 401) {
        navigate("/page401");
        setIsLoading(false);
      } else if (response.status === 403) {
        navigate("/page403");
      } else {
        showSnackbar("server Error", "error");
        setIsLoading(false);
      }
    } catch (error) {
      showSnackbar("server Error", "error");
      setIsLoading(false);
    }
  };

  return (
    <>
      <LoaderComp isLoading={isLoading} />
      <Grid container spacing={2}>
        <Grid xs={12} sm={6} md={5} lg={4}>
          <HeadingCard label="Product Wise Revenue Report" />
        </Grid>
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4} md={3}>
                                  <Typography variant="h6">Select Country</Typography>
                                  <CustomTextFieldComp
                                    size="normal"
                                    select
                                    value={countryName}
                                    onChange={handleChangeCountry}
                                    fullWidth
                                    InputProps={{ style: { borderRadius: "10px" } }}
                                  >
                                    {countryList?.map((country) => (
                                      <MenuItem key={country.id} value={country.id}>
                                        {country.country_name}
                                      </MenuItem>
                                    ))}
                                  </CustomTextFieldComp>
                                </Grid>
              
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography variant="h6">Select Product</Typography>
                <CustomAutocompleteComp
                  size="small"
                  value={productName}
                  multiple
                  onChange={handleAllChhangeProduct}
                  options={allProductList}
                  getOptionLabel={(option) => option.name}
                  tooltipContent={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        style: { borderRadius: "14px" }, // Add borderRadius here
                      }}
                      size="small"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography variant="h6">Select Year</Typography>
                <CustomAutocompleteComp
                  fullWidth
                  value={selectedYear}
                  onChange={(event, value) => handleselectedYear(value)}
                  size="small"
                  options={years}
                  getOptionLabel={(option) => option.year}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography sx={{ visibility: "hidden" }}>
                  Spacing purpose
                </Typography>
                <SearchButton
                  size="small"
                  onClick={handleSearchData}
                  showIcon={true}
                >
                  Search
                </SearchButton>
              </Grid>
            </Grid>
          </MainCard>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={5}>
            {productData?.map((data, index) => (
              <Grid item xs={12} lg={4} sm={6} md={6}>
                <NewCardcomp
                  borderRadius="20px"
                  padding="20px"
                  hoverBgColor={index % 2 === 0 ? "#D5F6E1" : "#FFEDFB"}
                  onClick={() => getMoreDetails(data?.id)}
                  hoverEffect={true}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography textAlign="center" variant="h3">
                        {data?.name}
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Box
                        sx={{
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "row",
                          gap: 1,
                          padding: "5px",

                          borderRadius: "6px",
                        }}
                      >
                        <img src="/reporticon.png" alt="time" />
                        <Typography variant="h5">
                          Target :{data?.currency_symbol} {data?.target}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} mt={1}>
                      <Grid container gap={2} justifyContent="center">
                        <Box
                          variant="h6"
                          sx={{
                            background: "#F4F4F4",

                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                            gap: 1,
                            padding: "5px",

                            borderRadius: "6px",
                          }}
                        >
                          {/* <img
                              src="/newTestPrep/icon _Laptop_.png"
                              alt="img"
                              width={13}
                            />{" "} */}
                          <Typography variant="h6" color="#425166">
                            {" "}
                            Achieved : {data?.currency_symbol} {data?.achieved}
                          </Typography>
                        </Box>

                        <Box
                          variant="h6"
                          sx={{
                            background: "#F4F4F4",

                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                            gap: 1,
                            padding: "5px",

                            borderRadius: "6px",
                          }}
                        >
                          {/* <img
                              src="/newTestPrep/icon _Laptop_.png"
                              alt="img"
                              width={13}
                            />{" "} */}
                          <Typography variant="h6" color="#425166">
                            {" "}
                            Percentage : {data?.percentage}%
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </NewCardcomp>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={detailsPopup}
        onClose={handleClosePopup}
        title="Monthly Revenue Report"
        component={
          <ProductDetailsData data={detailsData} year={selectedYear?.year} />
        }
        showDivider={true}
        maxWidth="sm"
      />
    </>
  );
}
